define(['jquery',
        'core/urls',
        'core/dynamic-forms'],
    function($, urls) {

        function haloConnectivityCheck(){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:halo-connectivity'](),
                dataType: 'json',
                success: function(data){
                     if(data.status === 'connected'){
                        $('#connectivity-status-checking-halo').hide();
                        $('#connectivity-status-halo p').hide();
                        $('#connectivity-status-connected-halo').show();
                        $('#connectivity-status-notconnected-halo').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking-halo').hide();
                        $('#connectivity-status-notconnected-halo').show();
                        $('#connectivity-status-connected-halo').hide();
                        $('#connectivity-status-halo p').show();
                    }
                }
            });
        }

        return {
            init: function() {
                haloConnectivityCheck();
                $(document).on('valid', 'form', function() {
                    haloConnectivityCheck();
                    if(!globals.has_generated_snippet) {
                        $('#continueToSurveyButton').prop('disabled', false);
                        $('#skipApiSetupLink').hide();
                    }
                });
            }
        };
    }
);
